import type { ReactNode } from "react";
import {
  NODE_HEADING,
  NODE_HR,
  NODE_OL,
  NODE_PARAGRAPH,
  NODE_QUOTE,
  NODE_UL,
} from "storyblok-rich-text-react-renderer";
import headingVariants from "modules/storyblok/adapters/Heading/Heading.config";
import { Divider } from "@chakra-ui/react";
import type { SbEditableComponentProps } from "types/storyblok";
import { Blockquote } from "components/Blockquote";
import type { RichtextAdapterProps } from "../../RichtextAdapter.d";
import { Heading, Paragraph, UlList, OlList } from "../../RichtextResolvers";

type LevelType = 1 | 2 | 3 | 4 | 5 | 6;

export const getNodeResolvers = ({
  sbEditable,
  customStyles,
}: SbEditableComponentProps<{ customStyles: RichtextAdapterProps["customStyles"] }>) => ({
  [NODE_HEADING]: (children: ReactNode, { level }: { level: LevelType }) => (
    <Heading as={`h${level}`} variant={headingVariants[level]} styles={customStyles?.heading} sbEditable={sbEditable}>
      {children}
    </Heading>
  ),
  [NODE_PARAGRAPH]: (children: ReactNode) => (
    <Paragraph styles={customStyles?.paragraph} sbEditable={sbEditable}>
      {children}
    </Paragraph>
  ),
  [NODE_HR]: () => <Divider sx={customStyles?.horizontalRule} />,
  [NODE_UL]: (children: ReactNode) => <UlList styles={customStyles?.list}>{children}</UlList>,
  [NODE_OL]: (children: ReactNode) => <OlList styles={customStyles?.list}>{children}</OlList>,
  [NODE_QUOTE]: (children: ReactNode) => <Blockquote>{children}</Blockquote>,
});
